import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';
import {API_BASE}from '../../utils/api';

const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async () => {
    try {
     
      const response = await axios.post(`${API_BASE}/api/auth/login`, {
        username,
        password
      });
      // console.log("Login API response:", response.data);

      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('username', response.data.username); 
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
        onLoginSuccess(response.data.token); 

      }
    } catch (err) {
      setError('Invalid username or password');
    }
  };

  return (
    
    <div className="login-container">
      <div className="login-box">
        <h2>Login</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={handleLogin}>Login</button>
        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
};

export default Login;

// import React, { useState } from 'react';
// import axios from 'axios';
// import './Login.css';
// import { API_BASE } from '../../utils/api';
// import { getCurrencySymbol } from '../../utils/currency'; // ⬅️ import your function

// const Login = ({ onLoginSuccess }) => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');

//   const handleLogin = async () => {
//     try {
//       const response = await axios.post(`${API_BASE}/api/auth/login`, {
//         username,
//         password
//       });

//       if (response.data.token) {
//         // Save token & username
//         localStorage.setItem('token', response.data.token);
//         localStorage.setItem('username', response.data.username); 
//         axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;

//         // 🔹 Fetch and cache currency symbol immediately after login
//         try {
//           const symbol = await getCurrencySymbol();
//           localStorage.setItem('currencySymbol', symbol); 
//         } catch (err) {
//           console.error("Currency fetch failed after login:", err);
//         }

//         // Proceed with login success flow
//         onLoginSuccess(response.data.token); 
//       }
//     } catch (err) {
//       setError('Invalid username or password');
//     }
//   };

//   return (
//     <div className="login-container">
//       <div className="login-box">
//         <h2>Login</h2>
//         <input
//           type="text"
//           placeholder="Username"
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />
//         <button onClick={handleLogin}>Login</button>
//         {error && <div className="error-message">{error}</div>}
//       </div>
//     </div>
//   );
// };

// export default Login;
